import { JsonFilterPipe } from '../../filters/json-filter.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatSidenavModule, MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { Router, NavigationEnd } from '@angular/router';

@Component({
	standalone: true,
	selector: 'drawer-summary',
	templateUrl: './drawer-summary.component.html',
	imports: [
		CommonModule, MatSidenavModule, MatSelectModule, JsonFilterPipe, 
		TranslatePipe, LoaderOverlayComponent, FormsModule
	]
})
export class DrawerSummaryComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private router: Router = inject(Router);
	
	@ViewChild('summaryDrawer') summaryDrawer: MatDrawer;
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	navigationSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
		this.vm.initialized = false;
	}
	
	ngOnInit() {
		this.vm.refToGpReason = '';
		this.vm.uid = 'ds-' + Date.now();
		this.vm.activeChatId = undefined;
		
		this.vm.problems = this.config.getSummaryProblems().map(function(item) {
			item['isSelected'] = false;
			return item;
		});
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, "toggleSummaryDrawer", (event, data) => {
					var reloadSolutionsNeeded: boolean = this.vm.activeChatId !== data.id;
					this.vm.chat = data;
					this.vm.activeChatId = data.id;
					if (reloadSolutionsNeeded) {
						if (this.isPreVisit()) {
							this.vm.solutions = this.config.getSummarySolutionsForPreVisit();
						} else {
							this.vm.solutions = this.config.getSummarySolutions();
						}
						this.vm.solution = this.vm.solutions[0]; // reset solution since solutions might have changed with chat switch
					}
					this.vm.isOpen = this.vm.chat.open;
					if (this.vm.isOpen) {
						this.angularStateHelperService.setGlobalProperty('noDocScroll', true);
						this.swapScroller(true);
						this.summaryDrawer.open();
					} else {
						this.close();
					}
				})
		);
		this.navigationSubscription = this.router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationEnd) {
					if (this.vm.isOpen) {
						this.close();
					}
				}
			}
		);
		
		this.vm.isProcessing = false;
		this.vm.customTerm = undefined;
		this.vm.isFinalState = false;
		
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.onProblemClick = this.onProblemClick;
		this.vm.isCustomTermRequired = this.isCustomTermRequired;
		this.vm.resetInputs = this.resetInputs;
		this.vm.close = this.close;
		this.vm.isPreVisit = this.isPreVisit;
		this.vm.changeToPreVisitFlow = this.changeToPreVisitFlow;
		this.vm.initialized = true;
	}
	
	ngOnDestroy() {
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	isCustomTermRequired() {
		var filteredResult: any = this.vm.problems.filter(function(item) {
			return item.labelCode === 'OTHER' && item.isSelected === true;
		});
		return filteredResult.length > 0;
	}
	
	onProblemClick($event, problem) {
		if (this.vm.isFinalState) return;
		this.vm.problems = this.vm.problems.map(function(item) {
			if (item.labelCode === problem.labelCode) {
				item.isSelected = !item.isSelected;
			}
			return item;
		});
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.isProcessing || !this.vm.solution) {
			this.vm.isPanelOpen = true;
			return;
		}
		if (!this.vm.isFinalState) {
			this.vm.isFinalState = true;
			return;
		}
		this.vm.isProcessing = true;
		
		var selectedProblems: any = this.vm.problems.filter(function(item) {
			return item.isSelected;
		});
		if (selectedProblems.length === 0) {
			selectedProblems = [{alias: 'No_answer'}];
		}
		
		var request: any = {
			user: {
				id: this.vm.chat.privateChatFriend.id
			},
			solution: this.vm.solution['alias'],
			problems: selectedProblems.map((item) => {
				if (item.labelCode === 'OTHER') {
					return {
						problem: item.alias,
						problemAsFreeText: this.vm.customTerm
					};
				} else {
					return {
						problem: item.alias
					};
				}
			})
		};
		if (this.isPreVisit()) {
			Object.assign(request, {
				preVisitInsuranceData: JSON.parse(this.vm.chat.preVisitMetaData.metadata), 
				refToGpReason: this.vm.refToGpReason
			});
		}
		
		this.serviceRestServices.submitSummary(request).then(() => {
			this.vm.isProcessing = false;
			this.vm.resetInputs();
			this.vm.close();
		});
	}
	
	resetInputs() {
		this.vm.refToGpReason = '';
		this.vm.submitted = false;
		this.vm.isFinalState = false;
		this.vm.customTerm = undefined;
		this.vm.solution = undefined;
		this.vm.problems = this.vm.problems.map(function(item) {
			item.isSelected = false;
			return item;
		})
	}
	
	close() {
		this.vm.chat.open = false;
		this.angularStateHelperService.setGlobalProperty('noDocScroll', false);
		this.swapScroller(false);
		this.summaryDrawer.close();
	}

	swapScroller(value) {
		if (value) {
			document.body.classList.add("u-no-scroll");
		} else {
			document.body.classList.remove("u-no-scroll");
		}
	}
	
	isPreVisit() {
		return this.vm.chat && this.vm.chat.preVisitMetaData && this.vm.chat.preVisitMetaData.type === 'PRE_VISIT';
	}
	
	changeToPreVisitFlow() {
		alert(this.angularFilterHelperService.translate('PreVisit.Record_Ticket_For_Person.Mental_Health_Ticket_Needed'));
	}
	
}